import { createSelector } from 'reselect';

// Types
import { ReviewTemplateTypeType, ReviewTemplateType } from 'Shared/types/ReviewTemplates.type';

// Constants
import ReviewTemplateConstants from 'Shared/constants/ReviewTemplates.constants';

// TODO (josh) : this key should come from a constant
const getReviewTemplateItems = state => state.reviewTemplates;

function createParameterSelector(selector) {
  return (_, params) => selector(params);
}

const getSlug = createParameterSelector(params => params.slug);
const getTemplateType = createParameterSelector(params => params.templateType as ReviewTemplateTypeType);
const getIncludeHidden = createParameterSelector(params => params?.includeHidden || false);

export const getAllReviewTemplates = createSelector([getReviewTemplateItems], reviews => {
  return reviews.get(ReviewTemplateConstants.State.REVIEWS_TEMPLATES_BY_SLUG);
});

export const getReviewTemplatesByTemplateType = createSelector(
  [getAllReviewTemplates, getTemplateType, getIncludeHidden],
  (templates, type, includeHidden) => {
    return templates
      .filter(template => template.get('templateType') === type)
      .filter(template => (includeHidden ? true : template.get('hidden') === false))
      .valueSeq()
      .toJS() as ReviewTemplateType[];
  }
);

export const getReviewTemplateBySlug = createSelector([getAllReviewTemplates, getSlug], (templates, slug) => {
  return templates.get(slug)?.toJS() as ReviewTemplateType[];
});
